import React from "react";

import GoodReadsLogo from "../../../assets/icons/Goodreads.png";

import "./clubModerator.scss";
interface ClubModeratorProps {
  picture: string;
  name: string;
  role: string;
  phrase: string;
  socials: Array<string>;
}

const ClubModerator = (props: ClubModeratorProps) => {
  const { picture, name, role, phrase, socials } = props;

  const renderIcon = (url: string) => {
    if (url.indexOf("facebook") !== -1) {
      return "icon-facebook";
    } else if (url.indexOf("instagram") !== -1) {
      return "icon-instagram";
    } else if (url.indexOf("twitter") !== -1) {
      return "icon-twitter";
    } else if (url.indexOf("linkedin") !== -1) {
      return "icon-linkedin";
    } else if (url.indexOf("goodreads") !== -1) {
      return "icon-goodreads";
    }
  };

  return (
    <div className="m-club-moderator">
      <div className="m-club-moderator__photo">
        <img src={picture} alt={`Foto ${name}`} />
      </div>
      <div className="m-club-moderator__texts">
        <p className="m-club-moderator__texts__name">{name}</p>
        <p className="m-club-moderator__texts__role">{role}</p>
        <p className="m-club-moderator__texts__phrase">{phrase}</p>
        {socials && socials.length > 0 && (
          <ul className="m-club-moderator__texts__socials">
            {socials.map((social, index) =>
              renderIcon(social) !== "icon-goodreads" ? (
                <li
                  className="m-club-moderator__texts__socials__item"
                  key={index}
                >
                  <a
                    className={`m-club-moderator__texts__socials__item__icon
                    ${renderIcon(social)}`}
                    href={social}
                    target="_blanck"
                    rel="noreferrer"
                  />
                </li>
              ) : (
                <li
                  className="m-club-moderator__texts__socials__item"
                  key={index}
                >
                  <a
                    className={`m-club-moderator__texts__socials__item__icon
                      ${renderIcon(social)}`
                    }
                    href={social}
                    target="_blanck"
                    rel="noreferrer"
                  >
                    <img src={GoodReadsLogo} alt={renderIcon(social)} />
                  </a>
                </li>
              )
            )}
          </ul>
        )}
      </div>
    </div>
  );
};

export default ClubModerator;
